<template>
  <tbody>
    <tr>
      <td :colspan="cols" style="border-bottom: 1px black solid">
        <p>
          Pedido:
          <strong class="separador-texto-corto">{{
            pedido.numeroVenta
          }}</strong>
          Pickeado por:
          <strong class="separador-texto">{{ responsable }}</strong>
          Tipo Pedido:
          <strong class="separador-texto-corto">{{ pedido.tipoPedido }}</strong>
          Tipo Entrega:
          <strong class="separador-texto-corto">
            {{ pedido.tipoEntrega.nombre }}
          </strong>
          Zona:
          <strong class="separador-texto">{{ zona }}</strong>
          Estado:
          <strong class="separador-texto-corto">{{ pedido.estado }}</strong>

          <strong
            v-if="pedido.fechaFacturacion && !pedido.estaProgramado"
            class="tag is-info"
            :style="estiloBadge"
          >
            {{ tiempo }}
          </strong>
          <strong
            v-if="pedido.fechaEntrega && pedido.estaProgramado"
            class="tag is-info"
            :style="estiloBadgeRestante"
          >
            {{ tiempoRestante }}
          </strong>
          <b-icon
            v-if="pedido.fechaEntrega && pedido.estaProgramado"
            icon="bell"
            type="is-danger"
          ></b-icon>
          <b-tooltip
            v-if="!hayAcciones && pedido.esCopia"
            class="is-pulled-right"
            type="is-info"
            label="Es copia"
            :delay="200"
          >
            <b-icon icon="copy" size="is-small" type="is-danger" />
          </b-tooltip>
        </p>
      </td>
      <td v-if="hayAcciones" style="border-bottom: 1px black solid">
        <b-tooltip
          v-if="puedeAsignarPedido"
          class="accion-pedido mr-1"
          type="is-info"
          label="Asignar picking"
          :delay="200"
        >
          <b-button
            type="is-info"
            size="is-small"
            title="Asignar picking"
            @click="asignarPedido(pedido.id)"
          >
            <b-icon icon="user-check" />
          </b-button>
        </b-tooltip>
        <b-tooltip
          v-if="puedeReimprimir"
          class="accion-pedido mr-1"
          type="is-info"
          label="Re-imprimir picking"
          :delay="200"
        >
          <b-button
            type="is-info"
            size="is-small"
            title="Re-imprimir picking"
            @click="imprimirPedido(pedido.id)"
          >
            <b-icon icon="print" />
          </b-button>
        </b-tooltip>
        <b-tooltip
          v-if="puedeDespachoPedido"
          class="accion-pedido mr-1"
          type="is-primary"
          label="Despachar pedido"
          :delay="200"
        >
          <router-link
            class="button is-small is-info"
            type="button"
            tag="button"
            title="Despachar pedido"
            :to="{ path: `/cierre/${pedido.id}` }"
          >
            <b-icon icon="box-open" />
          </router-link>
        </b-tooltip>
        <b-tooltip
          v-if="puedePausar"
          class="accion-pedido mr-1"
          type="is-info"
          :label="etiquetaBotonPausa"
          :delay="200"
        >
          <b-button
            type="is-info"
            size="is-small"
            :title="etiquetaBotonPausa"
            @click="pausarEjecucionPedido(pedido.id)"
          >
            <b-icon :icon="iconoEjecucion"></b-icon>
          </b-button>
        </b-tooltip>
        <b-tooltip
          v-if="pedido.esCopia"
          class="is-pulled-right"
          type="is-info"
          label="Es copia"
          :delay="200"
        >
          <b-icon icon="copy" size="is-small" type="is-danger" />
        </b-tooltip>
        <b-modal
          :active.sync="estaModalAbierto"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
          @close="cerrarModalHandle"
        >
          <seleccion-asignacion
            :bodega="bodega"
            :pedido="pedido"
            @cancelar="cerrarModalHandle"
          />
        </b-modal>
      </td>
      <td v-else style="border-bottom: 1px black solid"></td>
    </tr>
    <pedido-item-detalle
      v-for="item in pedido.items"
      :key="`item-detalle-${item.id}`"
      :item="item"
    />
  </tbody>
</template>

<script>
import { differenceInHours, differenceInMinutes, parseISO } from 'date-fns'
import { mapGetters } from 'vuex'

import SeleccionAsignacion from '@/components/monitorUsuario/SeleccionAsignacion.vue'
import PedidoItemDetalle from '@/components/monitorZona/PedidoItemDetalle.vue'
import { pedidoService } from '@/services'

export default {
  name: 'PedidoItemDetalleGrupo',
  components: {
    SeleccionAsignacion,
    PedidoItemDetalle
  },
  props: {
    pedido: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ahora: Date.now(),
      intervalo: null,
      estaModalAbierto: false,
      espera: {
        maximo: 40,
        minimo: 10
      },
      estilo: {
        fondo: 'white',
        texto: 'black',
        sombra: null,
        hue: 0
      }
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    responsable() {
      return this.pedido.responsable
        ? this.pedido.responsable.nombre
        : 'No asignado'
    },
    zona() {
      if (this.pedido.zona) return this.pedido.zona.nombre
      return this.pedido.tipoPedido === 'Múltiple' ? 'Varias' : 'Sin Zona'
    },
    hayAcciones() {
      return (
        (this.bodega.puedeReimprimir || this.bodega.puedePickearVendedor) &&
        // Si usuario tiene rol Monitor, no se muestran acciones
        !this.bodega.roles.some((rol) => rol.id === 6)
      )
    },
    cols() {
      return 9
    },
    puedeReimprimir() {
      return (
        this.bodega.puedeReimprimir &&
        this.pedido.estado.toLowerCase() === 'enejecucion' &&
        !this.esPedidoMultiplePadre
      )
    },
    puedeAsignarPedido() {
      return (
        this.bodega.puedePickearVendedor &&
        this.pedido.estado.toLowerCase() === 'clasificado' &&
        !this.esPedidoMultiplePadre
      )
    },
    puedeDespachoPedido() {
      return (
        this.pedido.estado.toLowerCase() === 'completado' &&
        (this.esPedidoMultiplePadre || !this.pedido.esSubpedido)
      )
    },
    puedePausar() {
      if (this.esPedidoMultiplePadre) return false
      const estados = ['asignado', 'enejecucion']
      if (!estados.includes(this.pedido.estado.toLowerCase())) return false
      const tipoEntrega = this.bodega.tiposEntrega.find(
        (te) => te.id === this.pedido.tipoEntrega.id
      )
      return tipoEntrega.puedePausar || this.pedido.puedePausarse
    },
    iconoEjecucion() {
      return this.pedido.estaPausado ||
        this.pedido.estado.toLowerCase() === 'asignado'
        ? 'play'
        : 'pause'
    },
    etiquetaBotonPausa() {
      return this.pedido.estaPausado ? 'Reanudar pedido' : 'Pausar pedido'
    },
    tiempo() {
      if (!this.pedido.fechaFacturacion) return ''
      const horas = differenceInHours(
        this.ahora,
        parseISO(this.pedido.fechaFacturacion)
      )
        .toString()
        .padStart(2, '0')
      const minutos = (
        differenceInMinutes(
          this.ahora,
          parseISO(this.pedido.fechaFacturacion)
        ) -
        horas * 60
      )
        .toString()
        .padStart(2, '0')
      return `hace ${horas}:${minutos}`
    },
    tiempoRestante() {
      if (!this.pedido.estaProgramado) return ''
      if (!this.pedido.fechaEntrega) return ''
      const horas = differenceInHours(
        parseISO(this.pedido.fechaEntrega),
        this.ahora
      )
        .toString()
        .padStart(2, '0')
      const minutos = (
        differenceInMinutes(parseISO(this.pedido.fechaEntrega), this.ahora) -
        horas * 60
      )
        .toString()
        .padStart(2, '0')
      if (horas < 0 || minutos < 0) return 'queda 00:00'
      return `queda ${horas}:${minutos}`
    },
    estiloBadge() {
      let estilo = {
        'background-color': this.estilo.fondo,
        color: this.estilo.texto
      }
      if (this.estilo.sombra) {
        estilo = Object.assign(estilo, { 'text-shadow': this.estilo.sombra })
      }
      return estilo
    },
    estiloBadgeRestante() {
      let estilo = {
        'background-color': this.estilo.fondo,
        color: this.estilo.texto
      }
      if (this.estilo.sombra) {
        estilo = Object.assign(estilo, { 'text-shadow': this.estilo.sombra })
      }
      return estilo
    },
    minutos() {
      return differenceInMinutes(
        this.ahora,
        parseISO(this.pedido.fechaFacturacion)
      )
    },
    minutosRestantes() {
      return differenceInMinutes(parseISO(this.pedido.fechaEntrega), this.ahora)
    }
  },
  watch: {
    item() {
      if (this.pedido.fechaFacturacion) this.calcularTiempo()
    }
  },
  created() {
    this.espera = {
      minimo: parseInt(process.env.VUE_APP_MIN_ESPERA ?? 0),
      maximo: parseInt(process.env.VUE_APP_MAX_ESPERA ?? 15)
    }
  },
  mounted() {
    const self = this
    this.calcularTiempo()
    const tiempo = this.pedido.estaProgramado ? 60000 : 30000
    this.intervalo = setInterval(() => self.calcularTiempo(), tiempo)
  },
  beforeDestroy() {
    clearInterval(this.intervalo)
  },
  methods: {
    asignarPedido() {
      this.estaModalAbierto = true
    },
    cerrarModalHandle() {
      this.estaModalAbierto = false
    },
    calcularColorFondo() {
      const opacidad = 1
      const hue = this.estilo.hue
      return `hsla(${hue}, 100%, 50%, ${opacidad})`
    },
    calcularColorTexto() {
      const hue = this.estilo.hue
      if (hue >= 45) return '#000'
      return '#fff'
    },
    calcularColorSombra() {
      const hue = this.estilo.hue
      let color = '#000'
      if (hue >= 45) color = '#fff'
      return `2px 2px 4px ${color}`
    },
    calcularHue() {
      const maxHue = 120
      const minHue = 0
      let porcentaje = 0
      if (this.pedido.estaProgramado) {
        if (this.minutosRestantes < 0) return minHue
        if (this.minutosRestantes > this.pedido.minutosPrevioAsignacion)
          return maxHue
        porcentaje = (
          this.minutosRestantes / this.pedido.minutosPrevioAsignacion
        ).toFixed(2)
      } else {
        if (this.minutos > this.espera.maximo) return minHue
        porcentaje = (1 - this.minutos / this.espera.maximo).toFixed(2)
      }
      const hue = porcentaje * (maxHue - minHue) + minHue
      return hue
    },
    calcularTiempo() {
      this.ahora = new Date()
      this.estilo.hue = this.calcularHue()
      this.estilo = {
        fondo: this.calcularColorFondo(),
        texto: this.calcularColorTexto(),
        sombra: this.calcularColorSombra()
      }
    },
    imprimirPedido(id) {
      pedidoService
        .imprimirPedido(id)
        .then(() => {
          this.notificarAccionCompletada(
            'Se envió impresión de picking list correctamente'
          )
        })
        .catch((error) => this.procesarError(error))
    },
    pausarEjecucionPedido(id) {
      const accion = this.pedido.estaPausado ? 'reanudó' : 'pausó'
      pedidoService
        .pausarEjecucionPedido(id)
        .then((rs) => {
          const { items, ...rest } = rs.data
          this.$store.commit('monitorZona/PEDIDO_UPDATE', rest)
          this.notificarAccionCompletada(
            `Se ${accion} la ejecución del pedido correctamente`
          )
        })
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>

<style lang="scss" scoped>
.botonera {
  margin-bottom: 0.5em;
}

.cabecera-detalle {
  margin-top: 15px;
  margin-bottom: 20px;
}
.separador-texto {
  display: inline-block;
  width: 14em;
}
.separador-texto-corto {
  display: inline-block;
  width: 8em;
}
</style>
